import React from "react";
import styles from "./skeleton.css";

const Skeleton = () => {
    return (
        <div styleName={"styles.carCard"}>
            <div className="shimmer" styleName={"styles.shimmerImg"} />
            <h4 className="shimmer" styleName={"styles.shimmer"} />
            <h4 className="shimmer" styleName={"styles.shimmer"} />
            <h4 className="shimmer" styleName={"styles.shimmer"} />
        </div>
    );
};

export default Skeleton;
